<template>
  <div class="training-plans practicepage">
    <div
      class="practicepage_inner"
      style="max-width: clamp(12rem, 75.5rem, 100vw); z-index: 2; position: relative"
    >
      <StudyPlan
        v-if="item"
        class="pb-16"
        :item="item"
      >
      </StudyPlan>
      <div
        v-else
        class="f-center text-large f-column py-12 flex-1"
      >
        <div class="gw_box flex-1 pa-12 w-100 f-center f-column">
          <div class="mdi mdi-alert-circle-outline text-mega clr-error"></div>
          <div class="clr-grey text-center">
            {{ $t('study_plans.plan_not_found') }}
          </div>
        </div>
        <router-link
          :to="{ name: 'StudyPlansRoot' }"
          class="clr-grey f-center text-semi-large mx-auto uppercase mt-4"
        >
          <span class="mdi mdi-chevron-left text-big mr-1"></span>
          <span class="link-underline link-underline_hover my-auto">
            {{ $t('study_plans.back_to_plans') }}
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import StudyPlan from '@/components/StudyPlans/StudyPlan'
import plans from '@/components/StudyPlans/study_plans'

export default {
  name: 'StudyPlansDashboard',
  components: {
    StudyPlan,
  },
  data() {
    return {}
  },

  computed: {
    item() {
      const res = plans.find(i => i.id === this.$route.params.id)
      return res
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>
